import { render, staticRenderFns } from "./ConfigurationWizardAccessControls.vue?vue&type=template&id=c20cfd78&scoped=true&"
import script from "./ConfigurationWizardAccessControls.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWizardAccessControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20cfd78",
  null
  
)

export default component.exports